import React from 'react';
import styled from 'styled-components';

const DividerItem = styled.div`
  padding: 7px 16px 8px 15px;
  height: 30px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    background: rgba(0, 0, 0, 0.03);
  }

  .hr {
    display: block;
    background: url(https://t1.daumcdn.net/keditor/dist/0.8.9/image/content-icon.svg)
      no-repeat;
    background-size: 430px 350px;
    width: 146px;
    padding: 0;
  }

  .hr-style1 {
    background-position: -280px -100px;
    height: 4px;
    width: 46px;
    margin: 6px 0 5px 5px;
  }

  .hr-style2 {
    background-position: -280px -120px;
    height: 2px;
    width: 46px;
    margin: 7px 0 6px 5px;
  }

  .hr-style3 {
    background-position: -280px -140px;
    height: 7px;
    margin: 5px 0 3px 5px;
    width: 50px;
  }

  .hr-style4 {
    background-position: -280px -160px;
    height: 20px;
    width: 2px;
    margin: -2px 0 0 5px;
  }
  .hr-style5 {
    background-position: -280px -180px;
    width: 146px;
    height: 2px;
    margin: 7px 0 6px 1px;
  }
  .hr-style6 {
    background-position: -280px -200px;
    height: 2px;
    margin: 7px 0 6px 1px;
  }
  .hr-style7 {
    background-position: -280px -220px;
    width: 95px;
    height: 13px;
    margin: 1px 0 1px 5px;
  }
  .hr-style8 {
    background-position: -280px -240px;
    width: 95px;
    height: 13px;
    margin: 1px 0px 1px 5px;
  }
`;

const DividerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

type Props = { handleDivider: any };
function HrList({ handleDivider }: Props) {
  return (
    <>
      <DividerWrapper>
        {Array.from({ length: 7 }).map((item, i) => {
          return (
            <DividerItem
              key={i}
              onClick={() => handleDivider(`style${i + 1}`)}
              style={{ color: 'black' }}
            >
              {/* style{i + 1} */}
              <i className={`hr hr-style${i + 1}`} />
            </DividerItem>
          );
        })}
      </DividerWrapper>
    </>
  );
}

export default HrList;
